export default __webpack_public_path__ + "static/media/exam-list-icon.e2a87d6d.svg";